var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9974 0L12.8544 0.848528L0.856991 12.7279L3.40506e-05 11.8794L11.9974 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1456 0.848557L12.0026 2.83849e-05L24 11.8794L23.143 12.7279L11.1456 0.848557Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5133 24L11.5133 1.19999L12.7252 1.19999L12.7252 24L11.5133 24Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuOTk3NCAwTDEyLjg1NDQgMC44NDg1MjhMMC44NTY5OTEgMTIuNzI3OUwzLjQwNTA2ZS0wNSAxMS44Nzk0TDExLjk5NzQgMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGQ9Ik0xMS4xNDU2IDAuODQ4NTU3TDEyLjAwMjYgMi44Mzg0OWUtMDVMMjQgMTEuODc5NEwyMy4xNDMgMTIuNzI3OUwxMS4xNDU2IDAuODQ4NTU3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41MTMzIDI0TDExLjUxMzMgMS4xOTk5OUwxMi43MjUyIDEuMTk5OTlMMTIuNzI1MiAyNEwxMS41MTMzIDI0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { ForwardRef as ReactComponent };